export enum ShippingTypeEnum {
  NAD = 'NAD',
  SALES_CHANNEL = 'SALES_CHANNEL',
}
